import Main from "./Main";

export const Register = () => {
  return <Main />;
};
